import { Modal, Title } from '@mantine/core';
import ChevronRightIcon from '../assets/ChevronRightIcon';
import PicIcon from '../assets/PicIcon';
import PicPlusIcon from '../assets/PicPlusIcon';

export default function AdaugaCrediteModal({opened, onClose}) {

    return (
        <Modal
            opened={opened}
            onClose={() => onClose()}
            size={500}
        >
            <div className="w-full">
                <Title style={{color:'#3C3C3C'}} order={2} align="center">Cumpară planșe</Title>
                <div className="flex flex-col justify-center items-center mt-8">


                    <a href="https://form.jotform.com/222843649243056" alt="picboard-price" className="flex items-center justify-between w-full cursor-pointer hover:bg-gray-100 px-4 py-1.5">
                        <div className="flex items-center gap-x-4">
                            <PicIcon width={50} height={50} fill="#3C3C3C" />
                            <div className="leading-[20px]">
                                <h1 className="text-lg font-[500] text-[#3C3C3C]">1 Planșă</h1>
                                <p className="text-gray-500 text-sm">Pachet Single</p>
                            </div>
                        </div>
                        <div className='flex items-center gap-x-2'>
                            <h1 className="text-xl font-[600] text-[#3C3C3C]">Cere ofertă</h1>
                            <ChevronRightIcon width={18} height={18} />
                        </div>
                    </a>
                    {/*<div className="h-[1px] mt-2 mb-2 bg-gray-100 w-full" />*/}

                    {/*<a href="https://buy.stripe.com/4gwdUSefhcd3bHa8wy" alt="picboard-price" className="flex items-center justify-between w-full cursor-pointer hover:bg-gray-100 px-4 py-1.5">*/}
                    {/*    <div className="flex items-center gap-x-4">*/}
                    {/*        <PicPlusIcon width={50} height={50} fill="#3C3C3C" />*/}
                    {/*        <div className="leading-[20px]">*/}
                    {/*            <h1 className="text-lg font-[500] text-[#3C3C3C]">10 Planșe</h1>*/}
                    {/*            <p className="text-gray-500 text-sm">Pachet Smart</p>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className='flex items-center gap-x-2'>*/}
                    {/*        <h1 className="text-xl font-[600] text-[#3C3C3C]">40€</h1>*/}
                    {/*        <ChevronRightIcon width={18} height={18} />*/}
                    {/*    </div>*/}
                    {/*</a>*/}
                    {/*<div className="h-[1px] mt-2 mb-2 bg-gray-100 w-full" />*/}

                    {/*<a href="https://buy.stripe.com/00g4kifjl90R26AcMN" alt="picboard-price" className="flex items-center justify-between w-full cursor-pointer hover:bg-gray-100 px-4 py-1.5">*/}
                    {/*    <div className="flex items-center gap-x-4">*/}
                    {/*        <PicPlusIcon width={50} height={50} fill="#3C3C3C" />*/}
                    {/*        <div className="leading-[20px]">*/}
                    {/*            <h1 className="text-lg font-[500] text-[#3C3C3C]">50 Planșe</h1>*/}
                    {/*            <p className="text-gray-500 text-sm">Pachet Economic</p>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*    <div className='flex items-center gap-x-2'>*/}
                    {/*        <h1 className="text-xl font-[600] text-[#3C3C3C]">30€</h1>*/}
                    {/*        <ChevronRightIcon width={18} height={18} />*/}
                    {/*    </div>*/}
                    {/*</a>*/}
                    <div className="h-[1px] mt-2 mb-2 bg-gray-100 w-full" />

                </div>
            </div>

            {/* <List>
                <List.Item><Button component={'a'} href={'https://buy.stripe.com/8wMaIGdbd2Cth1u288'}>1 Plansa (50E)</Button></List.Item>
                <List.Item><Button component={'a'} href={'https://buy.stripe.com/4gwdUSefhcd3bHa8wy'}>10 Planse (30E)</Button></List.Item>
                <List.Item><Button component={'a'} href={'https://buy.stripe.com/00g4kifjl90R26AcMN'}>50 Planse (50E)</Button> </List.Item>
            </List> */}


        </Modal>
    );
}